import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import { CallService } from './-call.service';

const API = `${environment.api}/api`;

@Injectable({
  providedIn: 'root'
})
export class BiensService {

  constructor(private http: HttpClient, private callService: CallService) { }

  getAllBiens(): Observable<any> {
    const httpOptions = this.callService.getHTTPOptionWithoutToken();
    return this.http.get(API + '/biens/displayed', httpOptions);
  }

  getBiens(): Observable<any> {
    const httpOptions = this.callService.getHTTPOptionWithoutToken();
    return this.http.get(API + '/biens/homeCarousel', httpOptions);
  }

  findBien(info: any) {
    const httpOptions = this.callService.getHTTPOptionWithoutToken();

    var tabData = {};
    tabData = {
      'transaction': info?.transaction,
      'commune': info?.commune,
      "type": info?.type,
      "around": info?.around,
    };
    const body = tabData;

    return this.http.post(API + '/findbiens', body, httpOptions);
  }

  getTypeBiens(): Observable<any> {
    const httpOptions = this.callService.getHTTPOptionWithoutToken();
    return this.http.get(API + '/typebien', httpOptions);
  }

  getCommunes(): Observable<any> {
    const httpOptions = this.callService.getHTTPOptionWithoutToken();
    return this.http.get(API + '/communes', httpOptions);
  }

  getBien(slug: string): Observable<any> {
    const httpOptions = this.callService.getHTTPOptionWithoutToken();
    return this.http.get(API + '/offre/' + slug, httpOptions);
  }
}
